import AbaBicRecord from './AbaBicRecord/AbaBicRecord';
import AbaBicRecordAck from './AbaBicRecordAck/AbaBicRecordAck';
import AbaBicRecordRej from './AbaBicRecordRej/AbaBicRecordRej';
import AbaFedRecord from './AbaFedRecord/AbaFedRecord';
import AbaFedRecordAck from './AbaFedRecordAck/AbaFedRecordAck';
import AbaFedRecordRej from './AbaFedRecordRej/AbaFedRecordRej';
import AccountAssetRestrictionRecord from './AccountAssetRestrictionRecord/AccountAssetRestrictionRecord';
import AccountBalanceRecord from './AccountBalanceRecord/AccountBalanceRecord';
import AccountClientGroupRecord from './AccountClientGroupRecord/AccountClientGroupRecord';
import AccountPositionRecord from './AccountPositionRecord/AccountPositionRecord';
import AccountPositionSnapshotRecord from './AccountPositionSnapshotRecord/AccountPositionSnapshotRecord';
import AccountRecord from './AccountRecord/AccountRecord';
import AccountRelationshipRecord from './AccountRelationshipRecord/AccountRelationshipRecord';
import AccountStatisticsReport from './AccountStatisticsReport/AccountStatisticsReport';
import AccountWithdrawalDataRecord from './AccountWithdrawalDataRecord/AccountWithdrawalDataRecord';
import AccountWithdrawalRelationshipRecord from './AccountWithdrawalRelationshipRecord/AccountWithdrawalRelationshipRecord';
import ACGUserRecord from './ACGUserRecord/ACGUserRecord';
import Activity from './Activity/Activity';
import AddressBookRecord from './AddressBookRecord/AddressBookRecord';
import AdminDepositExceptionReq from './AdminDepositExceptionReq/AdminDepositExceptionReq';
import AdminExtRecvExceptionReq from './AdminExtRecvExceptionReq/AdminExtRecvExceptionReq';
import AdminExtSendExceptionReq from './AdminExtSendExceptionReq/AdminExtSendExceptionReq';
import AdminRedeemExceptionReq from './AdminRedeemExceptionReq/AdminRedeemExceptionReq';
import Alert from './Alert/Alert';
import AMLApprovalAck from './AMLApprovalAck/AMLApprovalAck';
import AMLApprovalRej from './AMLApprovalRej/AMLApprovalRej';
import AMLApprovalReq from './AMLApprovalReq/AMLApprovalReq';
import AMLRecordApprovalAck from './AMLRecordApprovalAck/AMLRecordApprovalAck';
import AMLRecordApprovalRej from './AMLRecordApprovalRej/AMLRecordApprovalRej';
import AMLRecordApprovalReq from './AMLRecordApprovalReq/AMLRecordApprovalReq';
import AMLStatusAck from './AMLStatusAck/AMLStatusAck';
import AMLStatusRej from './AMLStatusRej/AMLStatusRej';
import AMLStatusReq from './AMLStatusReq/AMLStatusReq';
import APIAddConnectionReq from './APIAddConnectionReq/APIAddConnectionReq';
import APIAddFirmConnectionReq from './APIAddFirmConnectionReq/APIAddFirmConnectionReq';
import APIAddUserConnectionReq from './APIAddUserConnectionReq/APIAddUserConnectionReq';
import APIAdminAddConnectionRequest from './APIAdminAddConnectionRequest/APIAdminAddConnectionRequest';
import APIAdminAddUserConnectionRequest from './APIAdminAddUserConnectionRequest/APIAdminAddUserConnectionRequest';
import APIAdminDeleteApprovedAbaRequest from './APIAdminDeleteApprovedAbaRequest/APIAdminDeleteApprovedAbaRequest';
import APIAdminDeleteBicAbaRequest from './APIAdminDeleteBicAbaRequest/APIAdminDeleteBicAbaRequest';
import APIAdminDeleteConnectionRequest from './APIAdminDeleteConnectionRequest/APIAdminDeleteConnectionRequest';
import APIAdminDeleteUserConnectionRequest from './APIAdminDeleteUserConnectionRequest/APIAdminDeleteUserConnectionRequest';
import APIAdminDeleteUserRequest from './APIAdminDeleteUserRequest/APIAdminDeleteUserRequest';
import APIAdminModifyApprovedAbaRequest from './APIAdminModifyApprovedAbaRequest/APIAdminModifyApprovedAbaRequest';
import APIAdminModifyBicAbaRequest from './APIAdminModifyBicAbaRequest/APIAdminModifyBicAbaRequest';
import APIAdminModifyConnectionRequest from './APIAdminModifyConnectionRequest/APIAdminModifyConnectionRequest';
import APIAdminModifyFirmConnectionRequest from './APIAdminModifyFirmConnectionRequest/APIAdminModifyFirmConnectionRequest';
import APIAdminModifyFirmWireDataRequest from './APIAdminModifyFirmWireDataRequest/APIAdminModifyFirmWireDataRequest';
import APIAdminModifyUserConnectionRequest from './APIAdminModifyUserConnectionRequest/APIAdminModifyUserConnectionRequest';
import APIConnectionFirmsRecord from './APIConnectionFirmsRecord/APIConnectionFirmsRecord';
import APIConnectionRecord from './APIConnectionRecord/APIConnectionRecord';
import APIConnectionUsersRecord from './APIConnectionUsersRecord/APIConnectionUsersRecord';
import APIDeleteConnectionReq from './APIDeleteConnectionReq/APIDeleteConnectionReq';
import APIDeleteFirmConnectionReq from './APIDeleteFirmConnectionReq/APIDeleteFirmConnectionReq';
import APIDeleteUserConnectionReq from './APIDeleteUserConnectionReq/APIDeleteUserConnectionReq';
import APIModifyConnectionReq from './APIModifyConnectionReq/APIModifyConnectionReq';
import APIModifyFirmConnectionReq from './APIModifyFirmConnectionReq/APIModifyFirmConnectionReq';
import APIModifyUserConnectionReq from './APIModifyUserConnectionReq/APIModifyUserConnectionReq';
import APITransaction from './APITransaction/APITransaction';
import Asset from './Asset/Asset';
import AssetBalanceStatistics from './AssetBalanceStatistics/AssetBalanceStatistics';
import AvalancheGetTransactionDetailAck from './AvalancheGetTransactionDetailAck/AvalancheGetTransactionDetailAck';
import AvalancheGetTransactionDetailRej from './AvalancheGetTransactionDetailRej/AvalancheGetTransactionDetailRej';
import AvalancheGetTransactionDetailReq from './AvalancheGetTransactionDetailReq/AvalancheGetTransactionDetailReq';
import BankAPIAccountInquiryAck from './BankAPIAccountInquiryAck/BankAPIAccountInquiryAck';
import BankAPIAccountInquiryRej from './BankAPIAccountInquiryRej/BankAPIAccountInquiryRej';
import BankAPIAccountInquiryReq from './BankAPIAccountInquiryReq/BankAPIAccountInquiryReq';
import ClientMessageAck from './ClientMessageAck/ClientMessageAck';
import ClientMessageRecord from './ClientMessageRecord/ClientMessageRecord';
import ClientMessageRej from './ClientMessageRej/ClientMessageRej';
import ClientMessageReq from './ClientMessageReq/ClientMessageReq';
import ClientRoleRecord from './ClientRoleRecord/ClientRoleRecord';
import CollateralHistoryDetailRecord from './CollateralHistoryDetailRecord/CollateralHistoryDetailRecord';
import CollateralHistoryViewRecord from './CollateralHistoryViewRecord/CollateralHistoryViewRecord';
import CustomerAddAbaBicAck from './CustomerAddAbaBicAck/CustomerAddAbaBicAck';
import CustomerAddAbaBicRej from './CustomerAddAbaBicRej/CustomerAddAbaBicRej';
import CustomerAddAbaBicReq from './CustomerAddAbaBicReq/CustomerAddAbaBicReq';
import CustomerAddAbaFedAck from './CustomerAddAbaFedAck/CustomerAddAbaFedAck';
import CustomerAddAbaFedRej from './CustomerAddAbaFedRej/CustomerAddAbaFedRej';
import CustomerAddAbaFedReq from './CustomerAddAbaFedReq/CustomerAddAbaFedReq';
import CustomerAddAccountAck from './CustomerAddAccountAck/CustomerAddAccountAck';
import CustomerAddAccountRej from './CustomerAddAccountRej/CustomerAddAccountRej';
import CustomerAddAccountReq from './CustomerAddAccountReq/CustomerAddAccountReq';
import CustomerAddAccountWithdrawalDataAck from './CustomerAddAccountWithdrawalDataAck/CustomerAddAccountWithdrawalDataAck';
import CustomerAddAccountWithdrawalDataRej from './CustomerAddAccountWithdrawalDataRej/CustomerAddAccountWithdrawalDataRej';
import CustomerAddAccountWithdrawalDataReq from './CustomerAddAccountWithdrawalDataReq/CustomerAddAccountWithdrawalDataReq';
import CustomerAddAccountWithdrawalRelationshipAck from './CustomerAddAccountWithdrawalRelationshipAck/CustomerAddAccountWithdrawalRelationshipAck';
import CustomerAddAccountWithdrawalRelationshipRej from './CustomerAddAccountWithdrawalRelationshipRej/CustomerAddAccountWithdrawalRelationshipRej';
import CustomerAddAccountWithdrawalRelationshipReq from './CustomerAddAccountWithdrawalRelationshipReq/CustomerAddAccountWithdrawalRelationshipReq';
import CustomerAddACGAck from './CustomerAddACGAck/CustomerAddACGAck';
import CustomerAddACGRej from './CustomerAddACGRej/CustomerAddACGRej';
import CustomerAddACGReq from './CustomerAddACGReq/CustomerAddACGReq';
import CustomerAddACGUserRecordAck from './CustomerAddACGUserRecordAck/CustomerAddACGUserRecordAck';
import CustomerAddACGUserRecordRej from './CustomerAddACGUserRecordRej/CustomerAddACGUserRecordRej';
import CustomerAddACGUserReq from './CustomerAddACGUserReq/CustomerAddACGUserReq';
import CustomerAddAddressBookRecordAck from './CustomerAddAddressBookRecordAck/CustomerAddAddressBookRecordAck';
import CustomerAddAddressBookRecordRej from './CustomerAddAddressBookRecordRej/CustomerAddAddressBookRecordRej';
import CustomerAddAddressBookRecordReq from './CustomerAddAddressBookRecordReq/CustomerAddAddressBookRecordReq';
import CustomerAddEOAKeyReq from './CustomerAddEOAKeyReq/CustomerAddEOAKeyReq';
import CustomerAddFirmAccountAck from './CustomerAddFirmAccountAck/CustomerAddFirmAccountAck';
import CustomerAddFirmAccountRej from './CustomerAddFirmAccountRej/CustomerAddFirmAccountRej';
import CustomerAddFirmAccountReq from './CustomerAddFirmAccountReq/CustomerAddFirmAccountReq';
import CustomerAddFirmAck from './CustomerAddFirmAck/CustomerAddFirmAck';
import CustomerAddFirmRej from './CustomerAddFirmRej/CustomerAddFirmRej';
import CustomerAddFirmReq from './CustomerAddFirmReq/CustomerAddFirmReq';
import CustomerAddFirmWireDataReq from './CustomerAddFirmWireDataReq/CustomerAddFirmWireDataReq';
import CustomerAddUserAccountReq from './CustomerAddUserAccountReq/CustomerAddUserAccountReq';
import CustomerAddUserAck from './CustomerAddUserAck/CustomerAddUserAck';
import CustomerAddUserRej from './CustomerAddUserRej/CustomerAddUserRej';
import CustomerAddUserReq from './CustomerAddUserReq/CustomerAddUserReq';
import CustomerAddUserRoleReq from './CustomerAddUserRoleReq/CustomerAddUserRoleReq';
import CustomerAddWireAck from './CustomerAddWireAck/CustomerAddWireAck';
import CustomerAddWireRej from './CustomerAddWireRej/CustomerAddWireRej';
import CustomerAddWireReq from './CustomerAddWireReq/CustomerAddWireReq';
import CustomerApproveDeclineAck from './CustomerApproveDeclineAck/CustomerApproveDeclineAck';
import CustomerApproveDeclineRej from './CustomerApproveDeclineRej/CustomerApproveDeclineRej';
import CustomerApproveDeclineReq from './CustomerApproveDeclineReq/CustomerApproveDeclineReq';
import CustomerApproveUserValidationReq from './CustomerApproveUserValidationReq/CustomerApproveUserValidationReq';
import CustomerCancelAck from './CustomerCancelAck/CustomerCancelAck';
import CustomerCancelPledgeTransactionAck from './CustomerCancelPledgeTransactionAck/CustomerCancelPledgeTransactionAck';
import CustomerCancelPledgeTransactionRej from './CustomerCancelPledgeTransactionRej/CustomerCancelPledgeTransactionRej';
import CustomerCancelPledgeTransactionReq from './CustomerCancelPledgeTransactionReq/CustomerCancelPledgeTransactionReq';
import CustomerCancelRej from './CustomerCancelRej/CustomerCancelRej';
import CustomerCancelReq from './CustomerCancelReq/CustomerCancelReq';
import CustomerDeleteAbaBicAck from './CustomerDeleteAbaBicAck/CustomerDeleteAbaBicAck';
import CustomerDeleteAbaBicRej from './CustomerDeleteAbaBicRej/CustomerDeleteAbaBicRej';
import CustomerDeleteAbaBicReq from './CustomerDeleteAbaBicReq/CustomerDeleteAbaBicReq';
import CustomerDeleteAbaFedAck from './CustomerDeleteAbaFedAck/CustomerDeleteAbaFedAck';
import CustomerDeleteAbaFedRej from './CustomerDeleteAbaFedRej/CustomerDeleteAbaFedRej';
import CustomerDeleteAbaFedReq from './CustomerDeleteAbaFedReq/CustomerDeleteAbaFedReq';
import CustomerDeleteAccountReq from './CustomerDeleteAccountReq/CustomerDeleteAccountReq';
import CustomerDeleteAccountWithdrawalDataReq from './CustomerDeleteAccountWithdrawalDataReq/CustomerDeleteAccountWithdrawalDataReq';
import CustomerDeleteAccountWithdrawalRelationshipAck from './CustomerDeleteAccountWithdrawalRelationshipAck/CustomerDeleteAccountWithdrawalRelationshipAck';
import CustomerDeleteAccountWithdrawalRelationshipRej from './CustomerDeleteAccountWithdrawalRelationshipRej/CustomerDeleteAccountWithdrawalRelationshipRej';
import CustomerDeleteAccountWithdrawalRelationshipReq from './CustomerDeleteAccountWithdrawalRelationshipReq/CustomerDeleteAccountWithdrawalRelationshipReq';
import CustomerDeleteACGAck from './CustomerDeleteACGAck/CustomerDeleteACGAck';
import CustomerDeleteACGRej from './CustomerDeleteACGRej/CustomerDeleteACGRej';
import CustomerDeleteACGReq from './CustomerDeleteACGReq/CustomerDeleteACGReq';
import CustomerDeleteACGUserAck from './CustomerDeleteACGUserAck/CustomerDeleteACGUserAck';
import CustomerDeleteACGUserRej from './CustomerDeleteACGUserRej/CustomerDeleteACGUserRej';
import CustomerDeleteACGUserReq from './CustomerDeleteACGUserReq/CustomerDeleteACGUserReq';
import CustomerDeleteAddressBookRecordAck from './CustomerDeleteAddressBookRecordAck/CustomerDeleteAddressBookRecordAck';
import CustomerDeleteAddressBookRecordRej from './CustomerDeleteAddressBookRecordRej/CustomerDeleteAddressBookRecordRej';
import CustomerDeleteAddressBookRecordReq from './CustomerDeleteAddressBookRecordReq/CustomerDeleteAddressBookRecordReq';
import CustomerDeleteFirmAccountAck from './CustomerDeleteFirmAccountAck/CustomerDeleteFirmAccountAck';
import CustomerDeleteFirmAccountRej from './CustomerDeleteFirmAccountRej/CustomerDeleteFirmAccountRej';
import CustomerDeleteFirmAccountReq from './CustomerDeleteFirmAccountReq/CustomerDeleteFirmAccountReq';
import CustomerDeleteFirmAck from './CustomerDeleteFirmAck/CustomerDeleteFirmAck';
import CustomerDeleteFirmRej from './CustomerDeleteFirmRej/CustomerDeleteFirmRej';
import CustomerDeleteFirmReq from './CustomerDeleteFirmReq/CustomerDeleteFirmReq';
import CustomerDeleteFirmWireDataReq from './CustomerDeleteFirmWireDataReq/CustomerDeleteFirmWireDataReq';
import CustomerDeleteUserAccountReq from './CustomerDeleteUserAccountReq/CustomerDeleteUserAccountReq';
import CustomerDeleteUserAck from './CustomerDeleteUserAck/CustomerDeleteUserAck';
import CustomerDeleteUserRej from './CustomerDeleteUserRej/CustomerDeleteUserRej';
import CustomerDeleteUserReq from './CustomerDeleteUserReq/CustomerDeleteUserReq';
import CustomerDeleteUserRoleReq from './CustomerDeleteUserRoleReq/CustomerDeleteUserRoleReq';
import CustomerDepositApprovalReq from './CustomerDepositApprovalReq/CustomerDepositApprovalReq';
import CustomerDepositReq from './CustomerDepositReq/CustomerDepositReq';
import CustomerModifyAbaBicAck from './CustomerModifyAbaBicAck/CustomerModifyAbaBicAck';
import CustomerModifyAbaBicRej from './CustomerModifyAbaBicRej/CustomerModifyAbaBicRej';
import CustomerModifyAbaBicReq from './CustomerModifyAbaBicReq/CustomerModifyAbaBicReq';
import CustomerModifyAbaFedAck from './CustomerModifyAbaFedAck/CustomerModifyAbaFedAck';
import CustomerModifyAbaFedRej from './CustomerModifyAbaFedRej/CustomerModifyAbaFedRej';
import CustomerModifyAbaFedReq from './CustomerModifyAbaFedReq/CustomerModifyAbaFedReq';
import CustomerModifyAccountReq from './CustomerModifyAccountReq/CustomerModifyAccountReq';
import CustomerModifyAccountWithdrawalDataReq from './CustomerModifyAccountWithdrawalDataReq/CustomerModifyAccountWithdrawalDataReq';
import CustomerModifyACGAck from './CustomerModifyACGAck/CustomerModifyACGAck';
import CustomerModifyACGRej from './CustomerModifyACGRej/CustomerModifyACGRej';
import CustomerModifyACGReq from './CustomerModifyACGReq/CustomerModifyACGReq';
import CustomerModifyAddressBookRecordAck from './CustomerModifyAddressBookRecordAck/CustomerModifyAddressBookRecordAck';
import CustomerModifyAddressBookRecordRej from './CustomerModifyAddressBookRecordRej/CustomerModifyAddressBookRecordRej';
import CustomerModifyAddressBookRecordReq from './CustomerModifyAddressBookRecordReq/CustomerModifyAddressBookRecordReq';
import CustomerModifyEOAKeyReq from './CustomerModifyEOAKeyReq/CustomerModifyEOAKeyReq';
import CustomerModifyFirmAccountAck from './CustomerModifyFirmAccountAck/CustomerModifyFirmAccountAck';
import CustomerModifyFirmAccountRej from './CustomerModifyFirmAccountRej/CustomerModifyFirmAccountRej';
import CustomerModifyFirmAccountReq from './CustomerModifyFirmAccountReq/CustomerModifyFirmAccountReq';
import CustomerModifyFirmAck from './CustomerModifyFirmAck/CustomerModifyFirmAck';
import CustomerModifyFirmRej from './CustomerModifyFirmRej/CustomerModifyFirmRej';
import CustomerModifyFirmReq from './CustomerModifyFirmReq/CustomerModifyFirmReq';
import CustomerModifyFirmWireDataReq from './CustomerModifyFirmWireDataReq/CustomerModifyFirmWireDataReq';
import CustomerModifyUserAccountReq from './CustomerModifyUserAccountReq/CustomerModifyUserAccountReq';
import CustomerModifyUserAck from './CustomerModifyUserAck/CustomerModifyUserAck';
import CustomerModifyUserRej from './CustomerModifyUserRej/CustomerModifyUserRej';
import CustomerModifyUserReq from './CustomerModifyUserReq/CustomerModifyUserReq';
import CustomerModifyUserRoleReq from './CustomerModifyUserRoleReq/CustomerModifyUserRoleReq';
import CustomerOrderCancelAck from './CustomerOrderCancelAck/CustomerOrderCancelAck';
import CustomerOrderCancelRej from './CustomerOrderCancelRej/CustomerOrderCancelRej';
import CustomerOrderCancelReq from './CustomerOrderCancelReq/CustomerOrderCancelReq';
import CustomerOrderNewAck from './CustomerOrderNewAck/CustomerOrderNewAck';
import CustomerOrderNewRej from './CustomerOrderNewRej/CustomerOrderNewRej';
import CustomerOrderNewReq from './CustomerOrderNewReq/CustomerOrderNewReq';
import CustomerPendingApprovalAck from './CustomerPendingApprovalAck/CustomerPendingApprovalAck';
import CustomerPendingApproveDeclineAck from './CustomerPendingApproveDeclineAck/CustomerPendingApproveDeclineAck';
import CustomerPendingCancelAck from './CustomerPendingCancelAck/CustomerPendingCancelAck';
import CustomerPendingCancelPledgeTransactionAck from './CustomerPendingCancelPledgeTransactionAck/CustomerPendingCancelPledgeTransactionAck';
import CustomerPendingDepositAck from './CustomerPendingDepositAck/CustomerPendingDepositAck';
import CustomerPendingOrderCancelAck from './CustomerPendingOrderCancelAck/CustomerPendingOrderCancelAck';
import CustomerPendingOrderNewAck from './CustomerPendingOrderNewAck/CustomerPendingOrderNewAck';
import CustomerPendingRedeemAck from './CustomerPendingRedeemAck/CustomerPendingRedeemAck';
import CustomerPendingSendAck from './CustomerPendingSendAck/CustomerPendingSendAck';
import CustomerPendingWithdrawalAck from './CustomerPendingWithdrawalAck/CustomerPendingWithdrawalAck';
import CustomerPledgeAck from './CustomerPledgeAck/CustomerPledgeAck';
import CustomerPledgeAddOnAck from './CustomerPledgeAddOnAck/CustomerPledgeAddOnAck';
import CustomerPledgeAddOnPendingAck from './CustomerPledgeAddOnPendingAck/CustomerPledgeAddOnPendingAck';
import CustomerPledgeAddOnRej from './CustomerPledgeAddOnRej/CustomerPledgeAddOnRej';
import CustomerPledgeAddOnReq from './CustomerPledgeAddOnReq/CustomerPledgeAddOnReq';
import CustomerPledgePendingAck from './CustomerPledgePendingAck/CustomerPledgePendingAck';
import CustomerPledgeRej from './CustomerPledgeRej/CustomerPledgeRej';
import CustomerPledgeReq from './CustomerPledgeReq/CustomerPledgeReq';
import CustomerReclaimAck from './CustomerReclaimAck/CustomerReclaimAck';
import CustomerReclaimPendingAck from './CustomerReclaimPendingAck/CustomerReclaimPendingAck';
import CustomerReclaimRej from './CustomerReclaimRej/CustomerReclaimRej';
import CustomerReclaimReq from './CustomerReclaimReq/CustomerReclaimReq';
import CustomerRedeemApprovalReq from './CustomerRedeemApprovalReq/CustomerRedeemApprovalReq';
import CustomerRedeemReq from './CustomerRedeemReq/CustomerRedeemReq';
import CustomerReleaseAck from './CustomerReleaseAck/CustomerReleaseAck';
import CustomerReleasePendingAck from './CustomerReleasePendingAck/CustomerReleasePendingAck';
import CustomerReleaseRej from './CustomerReleaseRej/CustomerReleaseRej';
import CustomerReleaseReq from './CustomerReleaseReq/CustomerReleaseReq';
import CustomerSendApprovalReq from './CustomerSendApprovalReq/CustomerSendApprovalReq';
import CustomerSendReq from './CustomerSendReq/CustomerSendReq';
import CustomerTransferAck from './CustomerTransferAck/CustomerTransferAck';
import CustomerTransferPendingAck from './CustomerTransferPendingAck/CustomerTransferPendingAck';
import CustomerTransferRej from './CustomerTransferRej/CustomerTransferRej';
import CustomerTransferReq from './CustomerTransferReq/CustomerTransferReq';
import CustomerValidateBDAccountAck from './CustomerValidateBDAccountAck/CustomerValidateBDAccountAck';
import CustomerValidateBDAccountRej from './CustomerValidateBDAccountRej/CustomerValidateBDAccountRej';
import CustomerValidateBDAccountReq from './CustomerValidateBDAccountReq/CustomerValidateBDAccountReq';
import CustomerWireDepositReq from './CustomerWireDepositReq/CustomerWireDepositReq';
import CustomerWithdrawalAck from './CustomerWithdrawalAck/CustomerWithdrawalAck';
import CustomerWithdrawalApprovalAck from './CustomerWithdrawalApprovalAck/CustomerWithdrawalApprovalAck';
import CustomerWithdrawalApprovalRej from './CustomerWithdrawalApprovalRej/CustomerWithdrawalApprovalRej';
import CustomerWithdrawalApprovalReq from './CustomerWithdrawalApprovalReq/CustomerWithdrawalApprovalReq';
import CustomerWithdrawalRej from './CustomerWithdrawalRej/CustomerWithdrawalRej';
import CustomerWithdrawalReq from './CustomerWithdrawalReq/CustomerWithdrawalReq';
import EOAKeyRecord from './EOAKeyRecord/EOAKeyRecord';
import ExecutionRecord from './ExecutionRecord/ExecutionRecord';
import FeeAmountReq from './FeeAmountReq/FeeAmountReq';
import FeeRecord from './FeeRecord/FeeRecord';
import FirmAssetBalanceStatistics from './FirmAssetBalanceStatistics/FirmAssetBalanceStatistics';
import FirmAssetEntitlementReport from './FirmAssetEntitlementReport/FirmAssetEntitlementReport';
import FirmRecord from './FirmRecord/FirmRecord';
import FirmSecondaryApiTypeRecord from './FirmSecondaryApiTypeRecord/FirmSecondaryApiTypeRecord';
import FirmStatistics from './FirmStatistics/FirmStatistics';
import FirmStatisticsReport from './FirmStatisticsReport/FirmStatisticsReport';
import FirmWireDataRecord from './FirmWireDataRecord/FirmWireDataRecord';
import HistoryAck from './HistoryAck/HistoryAck';
import HistoryRej from './HistoryRej/HistoryRej';
import HistoryRequest from './HistoryRequest/HistoryRequest';
import LiquidityProviderOrderCancelAck from './LiquidityProviderOrderCancelAck/LiquidityProviderOrderCancelAck';
import LiquidityProviderOrderCancelRej from './LiquidityProviderOrderCancelRej/LiquidityProviderOrderCancelRej';
import LiquidityProviderPendingOrderCancelAck from './LiquidityProviderPendingOrderCancelAck/LiquidityProviderPendingOrderCancelAck';
import LiquidityStatistics from './LiquidityStatistics/LiquidityStatistics';
import NetAssetValueRecord from './NetAssetValueRecord/NetAssetValueRecord';
import OmnibusBalanceInquiryAck from './OmnibusBalanceInquiryAck/OmnibusBalanceInquiryAck';
import OmnibusBalanceInquiryRej from './OmnibusBalanceInquiryRej/OmnibusBalanceInquiryRej';
import OmnibusBalanceInquiryReq from './OmnibusBalanceInquiryReq/OmnibusBalanceInquiryReq';
import OmnibusBalanceUpdateAck from './OmnibusBalanceUpdateAck/OmnibusBalanceUpdateAck';
import OmnibusBalanceUpdatePendingAck from './OmnibusBalanceUpdatePendingAck/OmnibusBalanceUpdatePendingAck';
import OmnibusBalanceUpdateRej from './OmnibusBalanceUpdateRej/OmnibusBalanceUpdateRej';
import OmnibusBalanceUpdateReq from './OmnibusBalanceUpdateReq/OmnibusBalanceUpdateReq';
import OmnibusFiatBalanceInquiryAck from './OmnibusFiatBalanceInquiryAck/OmnibusFiatBalanceInquiryAck';
import OmnibusFiatBalanceInquiryRej from './OmnibusFiatBalanceInquiryRej/OmnibusFiatBalanceInquiryRej';
import OmnibusFiatBalanceInquiryReq from './OmnibusFiatBalanceInquiryReq/OmnibusFiatBalanceInquiryReq';
import OrderRecord from './OrderRecord/OrderRecord';
import PledgeParticipantRecord from './PledgeParticipantRecord/PledgeParticipantRecord';
import PledgeParticipantReport from './PledgeParticipantReport/PledgeParticipantReport';
import PledgeRecord from './PledgeRecord/PledgeRecord';
import PledgeReport from './PledgeReport/PledgeReport';
import PledgeTransactionRecord from './PledgeTransactionRecord/PledgeTransactionRecord';
import PledgeTransactionReport from './PledgeTransactionReport/PledgeTransactionReport';
import PostingFileRecord from './PostingFileRecord/PostingFileRecord';
import PriceRecord from './PriceRecord/PriceRecord';
import RacfDataRecord from './RacfDataRecord/RacfDataRecord';
import StatisticsReport from './StatisticsReport/StatisticsReport';
import StatisticsReportRecord from './StatisticsReportRecord/StatisticsReportRecord';
import StatisticsReports from './StatisticsReports/StatisticsReports';
import SystemKillSwitch from './SystemKillSwitch/SystemKillSwitch';
import SystemWireKillSwitch from './SystemWireKillSwitch/SystemWireKillSwitch';
import TotalInterestWebhookAck from './TotalInterestWebhookAck/TotalInterestWebhookAck';
import TotalTokenBalance from './TotalTokenBalance/TotalTokenBalance';
import Transaction from './Transaction/Transaction';
import UserAccountRecord from './UserAccountRecord/UserAccountRecord';
import UserRecord from './UserRecord/UserRecord';
import UserRole from './UserRole/UserRole';
import UserSecondaryApiTypeRecord from './UserSecondaryApiTypeRecord/UserSecondaryApiTypeRecord';
import UserValidationRecord from './UserValidationRecord/UserValidationRecord';
import ValidateApproveDeclineAck from './ValidateApproveDeclineAck/ValidateApproveDeclineAck';
import ValidateApproveDeclineRej from './ValidateApproveDeclineRej/ValidateApproveDeclineRej';
import ValidateApproveDeclineReq from './ValidateApproveDeclineReq/ValidateApproveDeclineReq';
import ValidateCancelAck from './ValidateCancelAck/ValidateCancelAck';
import ValidateCancelRej from './ValidateCancelRej/ValidateCancelRej';
import ValidateCancelReq from './ValidateCancelReq/ValidateCancelReq';
import WebhookSubscriptionRecord from './WebhookSubscriptionRecord/WebhookSubscriptionRecord';
import WireRoleRecord from './WireRoleRecord/WireRoleRecord';
import WireTransaction from './WireTransaction/WireTransaction';
import WireTransactionRej from './WireTransactionRej/WireTransactionRej';

export { AccountInterestStateEnum, AccountInterestStateEnumMap } from './AccountInterestStateEnum/AccountInterestStateEnum';
export { AMLStatusEnum, AMLStatusEnumMap } from './AMLStatusEnum/AMLStatusEnum';
export { APISecondaryConnectionEnum, APISecondaryConnectionEnumMap } from './APISecondaryConnectionEnum/APISecondaryConnectionEnum';
export { AssetPriceRejectEnum, AssetPriceRejectEnumMap } from './AssetPriceRejectEnum/AssetPriceRejectEnum';
export { BrokerDealerAPIStatusEnum, BrokerDealerAPIStatusEnumMap } from './BrokerDealerAPIStatusEnum/BrokerDealerAPIStatusEnum';
export { CancelTransactionTerminalTypeEnum, CancelTransactionTerminalTypeEnumMap } from './CancelTransactionTerminalTypeEnum/CancelTransactionTerminalTypeEnum';
export { ConfirmWireRejReasonEnum, ConfirmWireRejReasonEnumMap } from './ConfirmWireRejReasonEnum/ConfirmWireRejReasonEnum';
export { DBOperationEnum, DBOperationEnumMap } from './DBOperationEnum/DBOperationEnum';
export { EmailReasonEnum, EmailReasonEnumMap } from './EmailReasonEnum/EmailReasonEnum';
export { EntityTypeEnum, EntityTypeEnumMap } from './EntityTypeEnum/EntityTypeEnum';
export { FbApiCapabilitiesTransferTypesEnum, FbApiCapabilitiesTransferTypesEnumMap } from './FbApiCapabilitiesTransferTypesEnum/FbApiCapabilitiesTransferTypesEnum';
export { FbApiErrorRequestPartEnum, FbApiErrorRequestPartEnumMap } from './FbApiErrorRequestPartEnum/FbApiErrorRequestPartEnum';
export { FbErrorTypesEnum, FbErrorTypesEnumMap } from './FbErrorTypesEnum/FbErrorTypesEnum';
export { FeeSideApplyEnum, FeeSideApplyEnumMap } from './FeeSideApplyEnum/FeeSideApplyEnum';
export { FeeTypeEnum, FeeTypeEnumMap } from './FeeTypeEnum/FeeTypeEnum';
export { FREDTimerEventEnum, FREDTimerEventEnumMap } from './FREDTimerEventEnum/FREDTimerEventEnum';
export { InterestSessionStateEnum, InterestSessionStateEnumMap } from './InterestSessionStateEnum/InterestSessionStateEnum';
export { OrderRequestTypeEnum, OrderRequestTypeEnumMap } from './OrderRequestTypeEnum/OrderRequestTypeEnum';
export { OrderSideEnum, OrderSideEnumMap } from './OrderSideEnum/OrderSideEnum';
export { OrderStatusUpdateEnum, OrderStatusUpdateEnumMap } from './OrderStatusUpdateEnum/OrderStatusUpdateEnum';
export { OrderTypeEnum, OrderTypeEnumMap } from './OrderTypeEnum/OrderTypeEnum';
export { PurposeEnum, PurposeEnumMap } from './PurposeEnum/PurposeEnum';
export { TotalInterestStateEnum, TotalInterestStateEnumMap } from './TotalInterestStateEnum/TotalInterestStateEnum';
export { TransactionTypeEnum, TransactionTypeEnumMap } from './TransactionTypeEnum/TransactionTypeEnum';
export { TransferScopeEnum, TransferScopeEnumMap } from './TransferScopeEnum/TransferScopeEnum';
export { WebhookEventTypeEnum, WebhookEventTypeEnumMap } from './WebhookEventTypeEnum/WebhookEventTypeEnum';
export { WebhookNotificationStatusEnum, WebhookNotificationStatusEnumMap } from './WebhookNotificationStatusEnum/WebhookNotificationStatusEnum';
export { WebhookStatusEnum, WebhookStatusEnumMap } from './WebhookStatusEnum/WebhookStatusEnum';
export { WithdrawalTypeEnum, WithdrawalTypeEnumMap } from './WithdrawalTypeEnum/WithdrawalTypeEnum';

type CoreMsg = AbaBicRecord |
    AbaBicRecordAck |
    AbaBicRecordRej |
    AbaFedRecord |
    AbaFedRecordAck |
    AbaFedRecordRej |
    AccountAssetRestrictionRecord |
    AccountBalanceRecord |
    AccountClientGroupRecord |
    AccountPositionRecord |
    AccountPositionSnapshotRecord |
    AccountRecord |
    AccountRelationshipRecord |
    AccountStatisticsReport |
    AccountWithdrawalDataRecord |
    AccountWithdrawalRelationshipRecord |
    ACGUserRecord |
    Activity |
    AddressBookRecord |
    AdminDepositExceptionReq |
    AdminExtRecvExceptionReq |
    AdminExtSendExceptionReq |
    AdminRedeemExceptionReq |
    Alert |
    AMLApprovalAck |
    AMLApprovalRej |
    AMLApprovalReq |
    AMLRecordApprovalAck |
    AMLRecordApprovalRej |
    AMLRecordApprovalReq |
    AMLStatusAck |
    AMLStatusRej |
    AMLStatusReq |
    APIAddConnectionReq |
    APIAddFirmConnectionReq |
    APIAddUserConnectionReq |
    APIAdminAddConnectionRequest |
    APIAdminAddUserConnectionRequest |
    APIAdminDeleteApprovedAbaRequest |
    APIAdminDeleteBicAbaRequest |
    APIAdminDeleteConnectionRequest |
    APIAdminDeleteUserConnectionRequest |
    APIAdminDeleteUserRequest |
    APIAdminModifyApprovedAbaRequest |
    APIAdminModifyBicAbaRequest |
    APIAdminModifyConnectionRequest |
    APIAdminModifyFirmConnectionRequest |
    APIAdminModifyFirmWireDataRequest |
    APIAdminModifyUserConnectionRequest |
    APIConnectionFirmsRecord |
    APIConnectionRecord |
    APIConnectionUsersRecord |
    APIDeleteConnectionReq |
    APIDeleteFirmConnectionReq |
    APIDeleteUserConnectionReq |
    APIModifyConnectionReq |
    APIModifyFirmConnectionReq |
    APIModifyUserConnectionReq |
    APITransaction |
    Asset |
    AssetBalanceStatistics |
    AvalancheGetTransactionDetailAck |
    AvalancheGetTransactionDetailRej |
    AvalancheGetTransactionDetailReq |
    BankAPIAccountInquiryAck |
    BankAPIAccountInquiryRej |
    BankAPIAccountInquiryReq |
    ClientMessageAck |
    ClientMessageRecord |
    ClientMessageRej |
    ClientMessageReq |
    ClientRoleRecord |
    CollateralHistoryDetailRecord |
    CollateralHistoryViewRecord |
    CustomerAddAbaBicAck |
    CustomerAddAbaBicRej |
    CustomerAddAbaBicReq |
    CustomerAddAbaFedAck |
    CustomerAddAbaFedRej |
    CustomerAddAbaFedReq |
    CustomerAddAccountAck |
    CustomerAddAccountRej |
    CustomerAddAccountReq |
    CustomerAddAccountWithdrawalDataAck |
    CustomerAddAccountWithdrawalDataRej |
    CustomerAddAccountWithdrawalDataReq |
    CustomerAddAccountWithdrawalRelationshipAck |
    CustomerAddAccountWithdrawalRelationshipRej |
    CustomerAddAccountWithdrawalRelationshipReq |
    CustomerAddACGAck |
    CustomerAddACGRej |
    CustomerAddACGReq |
    CustomerAddACGUserRecordAck |
    CustomerAddACGUserRecordRej |
    CustomerAddACGUserReq |
    CustomerAddAddressBookRecordAck |
    CustomerAddAddressBookRecordRej |
    CustomerAddAddressBookRecordReq |
    CustomerAddEOAKeyReq |
    CustomerAddFirmAccountAck |
    CustomerAddFirmAccountRej |
    CustomerAddFirmAccountReq |
    CustomerAddFirmAck |
    CustomerAddFirmRej |
    CustomerAddFirmReq |
    CustomerAddFirmWireDataReq |
    CustomerAddUserAccountReq |
    CustomerAddUserAck |
    CustomerAddUserRej |
    CustomerAddUserReq |
    CustomerAddUserRoleReq |
    CustomerAddWireAck |
    CustomerAddWireRej |
    CustomerAddWireReq |
    CustomerApproveDeclineAck |
    CustomerApproveDeclineRej |
    CustomerApproveDeclineReq |
    CustomerApproveUserValidationReq |
    CustomerCancelAck |
    CustomerCancelPledgeTransactionAck |
    CustomerCancelPledgeTransactionRej |
    CustomerCancelPledgeTransactionReq |
    CustomerCancelRej |
    CustomerCancelReq |
    CustomerDeleteAbaBicAck |
    CustomerDeleteAbaBicRej |
    CustomerDeleteAbaBicReq |
    CustomerDeleteAbaFedAck |
    CustomerDeleteAbaFedRej |
    CustomerDeleteAbaFedReq |
    CustomerDeleteAccountReq |
    CustomerDeleteAccountWithdrawalDataReq |
    CustomerDeleteAccountWithdrawalRelationshipAck |
    CustomerDeleteAccountWithdrawalRelationshipRej |
    CustomerDeleteAccountWithdrawalRelationshipReq |
    CustomerDeleteACGAck |
    CustomerDeleteACGRej |
    CustomerDeleteACGReq |
    CustomerDeleteACGUserAck |
    CustomerDeleteACGUserRej |
    CustomerDeleteACGUserReq |
    CustomerDeleteAddressBookRecordAck |
    CustomerDeleteAddressBookRecordRej |
    CustomerDeleteAddressBookRecordReq |
    CustomerDeleteFirmAccountAck |
    CustomerDeleteFirmAccountRej |
    CustomerDeleteFirmAccountReq |
    CustomerDeleteFirmAck |
    CustomerDeleteFirmRej |
    CustomerDeleteFirmReq |
    CustomerDeleteFirmWireDataReq |
    CustomerDeleteUserAccountReq |
    CustomerDeleteUserAck |
    CustomerDeleteUserRej |
    CustomerDeleteUserReq |
    CustomerDeleteUserRoleReq |
    CustomerDepositApprovalReq |
    CustomerDepositReq |
    CustomerModifyAbaBicAck |
    CustomerModifyAbaBicRej |
    CustomerModifyAbaBicReq |
    CustomerModifyAbaFedAck |
    CustomerModifyAbaFedRej |
    CustomerModifyAbaFedReq |
    CustomerModifyAccountReq |
    CustomerModifyAccountWithdrawalDataReq |
    CustomerModifyACGAck |
    CustomerModifyACGRej |
    CustomerModifyACGReq |
    CustomerModifyAddressBookRecordAck |
    CustomerModifyAddressBookRecordRej |
    CustomerModifyAddressBookRecordReq |
    CustomerModifyEOAKeyReq |
    CustomerModifyFirmAccountAck |
    CustomerModifyFirmAccountRej |
    CustomerModifyFirmAccountReq |
    CustomerModifyFirmAck |
    CustomerModifyFirmRej |
    CustomerModifyFirmReq |
    CustomerModifyFirmWireDataReq |
    CustomerModifyUserAccountReq |
    CustomerModifyUserAck |
    CustomerModifyUserRej |
    CustomerModifyUserReq |
    CustomerModifyUserRoleReq |
    CustomerOrderCancelAck |
    CustomerOrderCancelRej |
    CustomerOrderCancelReq |
    CustomerOrderNewAck |
    CustomerOrderNewRej |
    CustomerOrderNewReq |
    CustomerPendingApprovalAck |
    CustomerPendingApproveDeclineAck |
    CustomerPendingCancelAck |
    CustomerPendingCancelPledgeTransactionAck |
    CustomerPendingDepositAck |
    CustomerPendingOrderCancelAck |
    CustomerPendingOrderNewAck |
    CustomerPendingRedeemAck |
    CustomerPendingSendAck |
    CustomerPendingWithdrawalAck |
    CustomerPledgeAck |
    CustomerPledgeAddOnAck |
    CustomerPledgeAddOnPendingAck |
    CustomerPledgeAddOnRej |
    CustomerPledgeAddOnReq |
    CustomerPledgePendingAck |
    CustomerPledgeRej |
    CustomerPledgeReq |
    CustomerReclaimAck |
    CustomerReclaimPendingAck |
    CustomerReclaimRej |
    CustomerReclaimReq |
    CustomerRedeemApprovalReq |
    CustomerRedeemReq |
    CustomerReleaseAck |
    CustomerReleasePendingAck |
    CustomerReleaseRej |
    CustomerReleaseReq |
    CustomerSendApprovalReq |
    CustomerSendReq |
    CustomerTransferAck |
    CustomerTransferPendingAck |
    CustomerTransferRej |
    CustomerTransferReq |
    CustomerValidateBDAccountAck |
    CustomerValidateBDAccountRej |
    CustomerValidateBDAccountReq |
    CustomerWireDepositReq |
    CustomerWithdrawalAck |
    CustomerWithdrawalApprovalAck |
    CustomerWithdrawalApprovalRej |
    CustomerWithdrawalApprovalReq |
    CustomerWithdrawalRej |
    CustomerWithdrawalReq |
    EOAKeyRecord |
    ExecutionRecord |
    FeeAmountReq |
    FeeRecord |
    FirmAssetBalanceStatistics |
    FirmAssetEntitlementReport |
    FirmRecord |
    FirmSecondaryApiTypeRecord |
    FirmStatistics |
    FirmStatisticsReport |
    FirmWireDataRecord |
    HistoryAck |
    HistoryRej |
    HistoryRequest |
    LiquidityProviderOrderCancelAck |
    LiquidityProviderOrderCancelRej |
    LiquidityProviderPendingOrderCancelAck |
    LiquidityStatistics |
    NetAssetValueRecord |
    OmnibusBalanceInquiryAck |
    OmnibusBalanceInquiryRej |
    OmnibusBalanceInquiryReq |
    OmnibusBalanceUpdateAck |
    OmnibusBalanceUpdatePendingAck |
    OmnibusBalanceUpdateRej |
    OmnibusBalanceUpdateReq |
    OmnibusFiatBalanceInquiryAck |
    OmnibusFiatBalanceInquiryRej |
    OmnibusFiatBalanceInquiryReq |
    OrderRecord |
    PledgeParticipantRecord |
    PledgeParticipantReport |
    PledgeRecord |
    PledgeReport |
    PledgeTransactionRecord |
    PledgeTransactionReport |
    PostingFileRecord |
    PriceRecord |
    RacfDataRecord |
    StatisticsReport |
    StatisticsReportRecord |
    StatisticsReports |
    SystemKillSwitch |
    SystemWireKillSwitch |
    TotalInterestWebhookAck |
    TotalTokenBalance |
    Transaction |
    UserAccountRecord |
    UserRecord |
    UserRole |
    UserSecondaryApiTypeRecord |
    UserValidationRecord |
    ValidateApproveDeclineAck |
    ValidateApproveDeclineRej |
    ValidateApproveDeclineReq |
    ValidateCancelAck |
    ValidateCancelRej |
    ValidateCancelReq |
    WebhookSubscriptionRecord |
    WireRoleRecord |
    WireTransaction |
    WireTransactionRej;

export enum CoreMsgTypes {
    AbaBicRecord = 'AbaBicRecord',
    AbaBicRecordAck = 'AbaBicRecordAck',
    AbaBicRecordRej = 'AbaBicRecordRej',
    AbaFedRecord = 'AbaFedRecord',
    AbaFedRecordAck = 'AbaFedRecordAck',
    AbaFedRecordRej = 'AbaFedRecordRej',
    AccountAssetRestrictionRecord = 'AccountAssetRestrictionRecord',
    AccountBalanceRecord = 'AccountBalanceRecord',
    AccountClientGroupRecord = 'AccountClientGroupRecord',
    AccountPositionRecord = 'AccountPositionRecord',
    AccountPositionSnapshotRecord = 'AccountPositionSnapshotRecord',
    AccountRecord = 'AccountRecord',
    AccountRelationshipRecord = 'AccountRelationshipRecord',
    AccountStatisticsReport = 'AccountStatisticsReport',
    AccountWithdrawalDataRecord = 'AccountWithdrawalDataRecord',
    AccountWithdrawalRelationshipRecord = 'AccountWithdrawalRelationshipRecord',
    ACGUserRecord = 'ACGUserRecord',
    Activity = 'Activity',
    AddressBookRecord = 'AddressBookRecord',
    AdminDepositExceptionReq = 'AdminDepositExceptionReq',
    AdminExtRecvExceptionReq = 'AdminExtRecvExceptionReq',
    AdminExtSendExceptionReq = 'AdminExtSendExceptionReq',
    AdminRedeemExceptionReq = 'AdminRedeemExceptionReq',
    Alert = 'Alert',
    AMLApprovalAck = 'AMLApprovalAck',
    AMLApprovalRej = 'AMLApprovalRej',
    AMLApprovalReq = 'AMLApprovalReq',
    AMLRecordApprovalAck = 'AMLRecordApprovalAck',
    AMLRecordApprovalRej = 'AMLRecordApprovalRej',
    AMLRecordApprovalReq = 'AMLRecordApprovalReq',
    AMLStatusAck = 'AMLStatusAck',
    AMLStatusRej = 'AMLStatusRej',
    AMLStatusReq = 'AMLStatusReq',
    APIAddConnectionReq = 'APIAddConnectionReq',
    APIAddFirmConnectionReq = 'APIAddFirmConnectionReq',
    APIAddUserConnectionReq = 'APIAddUserConnectionReq',
    APIAdminAddConnectionRequest = 'APIAdminAddConnectionRequest',
    APIAdminAddUserConnectionRequest = 'APIAdminAddUserConnectionRequest',
    APIAdminDeleteApprovedAbaRequest = 'APIAdminDeleteApprovedAbaRequest',
    APIAdminDeleteBicAbaRequest = 'APIAdminDeleteBicAbaRequest',
    APIAdminDeleteConnectionRequest = 'APIAdminDeleteConnectionRequest',
    APIAdminDeleteUserConnectionRequest = 'APIAdminDeleteUserConnectionRequest',
    APIAdminDeleteUserRequest = 'APIAdminDeleteUserRequest',
    APIAdminModifyApprovedAbaRequest = 'APIAdminModifyApprovedAbaRequest',
    APIAdminModifyBicAbaRequest = 'APIAdminModifyBicAbaRequest',
    APIAdminModifyConnectionRequest = 'APIAdminModifyConnectionRequest',
    APIAdminModifyFirmConnectionRequest = 'APIAdminModifyFirmConnectionRequest',
    APIAdminModifyFirmWireDataRequest = 'APIAdminModifyFirmWireDataRequest',
    APIAdminModifyUserConnectionRequest = 'APIAdminModifyUserConnectionRequest',
    APIConnectionFirmsRecord = 'APIConnectionFirmsRecord',
    APIConnectionRecord = 'APIConnectionRecord',
    APIConnectionUsersRecord = 'APIConnectionUsersRecord',
    APIDeleteConnectionReq = 'APIDeleteConnectionReq',
    APIDeleteFirmConnectionReq = 'APIDeleteFirmConnectionReq',
    APIDeleteUserConnectionReq = 'APIDeleteUserConnectionReq',
    APIModifyConnectionReq = 'APIModifyConnectionReq',
    APIModifyFirmConnectionReq = 'APIModifyFirmConnectionReq',
    APIModifyUserConnectionReq = 'APIModifyUserConnectionReq',
    APITransaction = 'APITransaction',
    Asset = 'Asset',
    AssetBalanceStatistics = 'AssetBalanceStatistics',
    AvalancheGetTransactionDetailAck = 'AvalancheGetTransactionDetailAck',
    AvalancheGetTransactionDetailRej = 'AvalancheGetTransactionDetailRej',
    AvalancheGetTransactionDetailReq = 'AvalancheGetTransactionDetailReq',
    BankAPIAccountInquiryAck = 'BankAPIAccountInquiryAck',
    BankAPIAccountInquiryRej = 'BankAPIAccountInquiryRej',
    BankAPIAccountInquiryReq = 'BankAPIAccountInquiryReq',
    ClientMessageAck = 'ClientMessageAck',
    ClientMessageRecord = 'ClientMessageRecord',
    ClientMessageRej = 'ClientMessageRej',
    ClientMessageReq = 'ClientMessageReq',
    ClientRoleRecord = 'ClientRoleRecord',
    CollateralHistoryDetailRecord = 'CollateralHistoryDetailRecord',
    CollateralHistoryViewRecord = 'CollateralHistoryViewRecord',
    CustomerAddAbaBicAck = 'CustomerAddAbaBicAck',
    CustomerAddAbaBicRej = 'CustomerAddAbaBicRej',
    CustomerAddAbaBicReq = 'CustomerAddAbaBicReq',
    CustomerAddAbaFedAck = 'CustomerAddAbaFedAck',
    CustomerAddAbaFedRej = 'CustomerAddAbaFedRej',
    CustomerAddAbaFedReq = 'CustomerAddAbaFedReq',
    CustomerAddAccountAck = 'CustomerAddAccountAck',
    CustomerAddAccountRej = 'CustomerAddAccountRej',
    CustomerAddAccountReq = 'CustomerAddAccountReq',
    CustomerAddAccountWithdrawalDataAck = 'CustomerAddAccountWithdrawalDataAck',
    CustomerAddAccountWithdrawalDataRej = 'CustomerAddAccountWithdrawalDataRej',
    CustomerAddAccountWithdrawalDataReq = 'CustomerAddAccountWithdrawalDataReq',
    CustomerAddAccountWithdrawalRelationshipAck = 'CustomerAddAccountWithdrawalRelationshipAck',
    CustomerAddAccountWithdrawalRelationshipRej = 'CustomerAddAccountWithdrawalRelationshipRej',
    CustomerAddAccountWithdrawalRelationshipReq = 'CustomerAddAccountWithdrawalRelationshipReq',
    CustomerAddACGAck = 'CustomerAddACGAck',
    CustomerAddACGRej = 'CustomerAddACGRej',
    CustomerAddACGReq = 'CustomerAddACGReq',
    CustomerAddACGUserRecordAck = 'CustomerAddACGUserRecordAck',
    CustomerAddACGUserRecordRej = 'CustomerAddACGUserRecordRej',
    CustomerAddACGUserReq = 'CustomerAddACGUserReq',
    CustomerAddAddressBookRecordAck = 'CustomerAddAddressBookRecordAck',
    CustomerAddAddressBookRecordRej = 'CustomerAddAddressBookRecordRej',
    CustomerAddAddressBookRecordReq = 'CustomerAddAddressBookRecordReq',
    CustomerAddEOAKeyReq = 'CustomerAddEOAKeyReq',
    CustomerAddFirmAccountAck = 'CustomerAddFirmAccountAck',
    CustomerAddFirmAccountRej = 'CustomerAddFirmAccountRej',
    CustomerAddFirmAccountReq = 'CustomerAddFirmAccountReq',
    CustomerAddFirmAck = 'CustomerAddFirmAck',
    CustomerAddFirmRej = 'CustomerAddFirmRej',
    CustomerAddFirmReq = 'CustomerAddFirmReq',
    CustomerAddFirmWireDataReq = 'CustomerAddFirmWireDataReq',
    CustomerAddUserAccountReq = 'CustomerAddUserAccountReq',
    CustomerAddUserAck = 'CustomerAddUserAck',
    CustomerAddUserRej = 'CustomerAddUserRej',
    CustomerAddUserReq = 'CustomerAddUserReq',
    CustomerAddUserRoleReq = 'CustomerAddUserRoleReq',
    CustomerAddWireAck = 'CustomerAddWireAck',
    CustomerAddWireRej = 'CustomerAddWireRej',
    CustomerAddWireReq = 'CustomerAddWireReq',
    CustomerApproveDeclineAck = 'CustomerApproveDeclineAck',
    CustomerApproveDeclineRej = 'CustomerApproveDeclineRej',
    CustomerApproveDeclineReq = 'CustomerApproveDeclineReq',
    CustomerApproveUserValidationReq = 'CustomerApproveUserValidationReq',
    CustomerCancelAck = 'CustomerCancelAck',
    CustomerCancelPledgeTransactionAck = 'CustomerCancelPledgeTransactionAck',
    CustomerCancelPledgeTransactionRej = 'CustomerCancelPledgeTransactionRej',
    CustomerCancelPledgeTransactionReq = 'CustomerCancelPledgeTransactionReq',
    CustomerCancelRej = 'CustomerCancelRej',
    CustomerCancelReq = 'CustomerCancelReq',
    CustomerDeleteAbaBicAck = 'CustomerDeleteAbaBicAck',
    CustomerDeleteAbaBicRej = 'CustomerDeleteAbaBicRej',
    CustomerDeleteAbaBicReq = 'CustomerDeleteAbaBicReq',
    CustomerDeleteAbaFedAck = 'CustomerDeleteAbaFedAck',
    CustomerDeleteAbaFedRej = 'CustomerDeleteAbaFedRej',
    CustomerDeleteAbaFedReq = 'CustomerDeleteAbaFedReq',
    CustomerDeleteAccountReq = 'CustomerDeleteAccountReq',
    CustomerDeleteAccountWithdrawalDataReq = 'CustomerDeleteAccountWithdrawalDataReq',
    CustomerDeleteAccountWithdrawalRelationshipAck = 'CustomerDeleteAccountWithdrawalRelationshipAck',
    CustomerDeleteAccountWithdrawalRelationshipRej = 'CustomerDeleteAccountWithdrawalRelationshipRej',
    CustomerDeleteAccountWithdrawalRelationshipReq = 'CustomerDeleteAccountWithdrawalRelationshipReq',
    CustomerDeleteACGAck = 'CustomerDeleteACGAck',
    CustomerDeleteACGRej = 'CustomerDeleteACGRej',
    CustomerDeleteACGReq = 'CustomerDeleteACGReq',
    CustomerDeleteACGUserAck = 'CustomerDeleteACGUserAck',
    CustomerDeleteACGUserRej = 'CustomerDeleteACGUserRej',
    CustomerDeleteACGUserReq = 'CustomerDeleteACGUserReq',
    CustomerDeleteAddressBookRecordAck = 'CustomerDeleteAddressBookRecordAck',
    CustomerDeleteAddressBookRecordRej = 'CustomerDeleteAddressBookRecordRej',
    CustomerDeleteAddressBookRecordReq = 'CustomerDeleteAddressBookRecordReq',
    CustomerDeleteFirmAccountAck = 'CustomerDeleteFirmAccountAck',
    CustomerDeleteFirmAccountRej = 'CustomerDeleteFirmAccountRej',
    CustomerDeleteFirmAccountReq = 'CustomerDeleteFirmAccountReq',
    CustomerDeleteFirmAck = 'CustomerDeleteFirmAck',
    CustomerDeleteFirmRej = 'CustomerDeleteFirmRej',
    CustomerDeleteFirmReq = 'CustomerDeleteFirmReq',
    CustomerDeleteFirmWireDataReq = 'CustomerDeleteFirmWireDataReq',
    CustomerDeleteUserAccountReq = 'CustomerDeleteUserAccountReq',
    CustomerDeleteUserAck = 'CustomerDeleteUserAck',
    CustomerDeleteUserRej = 'CustomerDeleteUserRej',
    CustomerDeleteUserReq = 'CustomerDeleteUserReq',
    CustomerDeleteUserRoleReq = 'CustomerDeleteUserRoleReq',
    CustomerDepositApprovalReq = 'CustomerDepositApprovalReq',
    CustomerDepositReq = 'CustomerDepositReq',
    CustomerModifyAbaBicAck = 'CustomerModifyAbaBicAck',
    CustomerModifyAbaBicRej = 'CustomerModifyAbaBicRej',
    CustomerModifyAbaBicReq = 'CustomerModifyAbaBicReq',
    CustomerModifyAbaFedAck = 'CustomerModifyAbaFedAck',
    CustomerModifyAbaFedRej = 'CustomerModifyAbaFedRej',
    CustomerModifyAbaFedReq = 'CustomerModifyAbaFedReq',
    CustomerModifyAccountReq = 'CustomerModifyAccountReq',
    CustomerModifyAccountWithdrawalDataReq = 'CustomerModifyAccountWithdrawalDataReq',
    CustomerModifyACGAck = 'CustomerModifyACGAck',
    CustomerModifyACGRej = 'CustomerModifyACGRej',
    CustomerModifyACGReq = 'CustomerModifyACGReq',
    CustomerModifyAddressBookRecordAck = 'CustomerModifyAddressBookRecordAck',
    CustomerModifyAddressBookRecordRej = 'CustomerModifyAddressBookRecordRej',
    CustomerModifyAddressBookRecordReq = 'CustomerModifyAddressBookRecordReq',
    CustomerModifyEOAKeyReq = 'CustomerModifyEOAKeyReq',
    CustomerModifyFirmAccountAck = 'CustomerModifyFirmAccountAck',
    CustomerModifyFirmAccountRej = 'CustomerModifyFirmAccountRej',
    CustomerModifyFirmAccountReq = 'CustomerModifyFirmAccountReq',
    CustomerModifyFirmAck = 'CustomerModifyFirmAck',
    CustomerModifyFirmRej = 'CustomerModifyFirmRej',
    CustomerModifyFirmReq = 'CustomerModifyFirmReq',
    CustomerModifyFirmWireDataReq = 'CustomerModifyFirmWireDataReq',
    CustomerModifyUserAccountReq = 'CustomerModifyUserAccountReq',
    CustomerModifyUserAck = 'CustomerModifyUserAck',
    CustomerModifyUserRej = 'CustomerModifyUserRej',
    CustomerModifyUserReq = 'CustomerModifyUserReq',
    CustomerModifyUserRoleReq = 'CustomerModifyUserRoleReq',
    CustomerOrderCancelAck = 'CustomerOrderCancelAck',
    CustomerOrderCancelRej = 'CustomerOrderCancelRej',
    CustomerOrderCancelReq = 'CustomerOrderCancelReq',
    CustomerOrderNewAck = 'CustomerOrderNewAck',
    CustomerOrderNewRej = 'CustomerOrderNewRej',
    CustomerOrderNewReq = 'CustomerOrderNewReq',
    CustomerPendingApprovalAck = 'CustomerPendingApprovalAck',
    CustomerPendingApproveDeclineAck = 'CustomerPendingApproveDeclineAck',
    CustomerPendingCancelAck = 'CustomerPendingCancelAck',
    CustomerPendingCancelPledgeTransactionAck = 'CustomerPendingCancelPledgeTransactionAck',
    CustomerPendingDepositAck = 'CustomerPendingDepositAck',
    CustomerPendingOrderCancelAck = 'CustomerPendingOrderCancelAck',
    CustomerPendingOrderNewAck = 'CustomerPendingOrderNewAck',
    CustomerPendingRedeemAck = 'CustomerPendingRedeemAck',
    CustomerPendingSendAck = 'CustomerPendingSendAck',
    CustomerPendingWithdrawalAck = 'CustomerPendingWithdrawalAck',
    CustomerPledgeAck = 'CustomerPledgeAck',
    CustomerPledgeAddOnAck = 'CustomerPledgeAddOnAck',
    CustomerPledgeAddOnPendingAck = 'CustomerPledgeAddOnPendingAck',
    CustomerPledgeAddOnRej = 'CustomerPledgeAddOnRej',
    CustomerPledgeAddOnReq = 'CustomerPledgeAddOnReq',
    CustomerPledgePendingAck = 'CustomerPledgePendingAck',
    CustomerPledgeRej = 'CustomerPledgeRej',
    CustomerPledgeReq = 'CustomerPledgeReq',
    CustomerReclaimAck = 'CustomerReclaimAck',
    CustomerReclaimPendingAck = 'CustomerReclaimPendingAck',
    CustomerReclaimRej = 'CustomerReclaimRej',
    CustomerReclaimReq = 'CustomerReclaimReq',
    CustomerRedeemApprovalReq = 'CustomerRedeemApprovalReq',
    CustomerRedeemReq = 'CustomerRedeemReq',
    CustomerReleaseAck = 'CustomerReleaseAck',
    CustomerReleasePendingAck = 'CustomerReleasePendingAck',
    CustomerReleaseRej = 'CustomerReleaseRej',
    CustomerReleaseReq = 'CustomerReleaseReq',
    CustomerSendApprovalReq = 'CustomerSendApprovalReq',
    CustomerSendReq = 'CustomerSendReq',
    CustomerTransferAck = 'CustomerTransferAck',
    CustomerTransferPendingAck = 'CustomerTransferPendingAck',
    CustomerTransferRej = 'CustomerTransferRej',
    CustomerTransferReq = 'CustomerTransferReq',
    CustomerValidateBDAccountAck = 'CustomerValidateBDAccountAck',
    CustomerValidateBDAccountRej = 'CustomerValidateBDAccountRej',
    CustomerValidateBDAccountReq = 'CustomerValidateBDAccountReq',
    CustomerWireDepositReq = 'CustomerWireDepositReq',
    CustomerWithdrawalAck = 'CustomerWithdrawalAck',
    CustomerWithdrawalApprovalAck = 'CustomerWithdrawalApprovalAck',
    CustomerWithdrawalApprovalRej = 'CustomerWithdrawalApprovalRej',
    CustomerWithdrawalApprovalReq = 'CustomerWithdrawalApprovalReq',
    CustomerWithdrawalRej = 'CustomerWithdrawalRej',
    CustomerWithdrawalReq = 'CustomerWithdrawalReq',
    EOAKeyRecord = 'EOAKeyRecord',
    ExecutionRecord = 'ExecutionRecord',
    FeeAmountReq = 'FeeAmountReq',
    FeeRecord = 'FeeRecord',
    FirmAssetBalanceStatistics = 'FirmAssetBalanceStatistics',
    FirmAssetEntitlementReport = 'FirmAssetEntitlementReport',
    FirmRecord = 'FirmRecord',
    FirmSecondaryApiTypeRecord = 'FirmSecondaryApiTypeRecord',
    FirmStatistics = 'FirmStatistics',
    FirmStatisticsReport = 'FirmStatisticsReport',
    FirmWireDataRecord = 'FirmWireDataRecord',
    HistoryAck = 'HistoryAck',
    HistoryRej = 'HistoryRej',
    HistoryRequest = 'HistoryRequest',
    LiquidityProviderOrderCancelAck = 'LiquidityProviderOrderCancelAck',
    LiquidityProviderOrderCancelRej = 'LiquidityProviderOrderCancelRej',
    LiquidityProviderPendingOrderCancelAck = 'LiquidityProviderPendingOrderCancelAck',
    LiquidityStatistics = 'LiquidityStatistics',
    NetAssetValueRecord = 'NetAssetValueRecord',
    OmnibusBalanceInquiryAck = 'OmnibusBalanceInquiryAck',
    OmnibusBalanceInquiryRej = 'OmnibusBalanceInquiryRej',
    OmnibusBalanceInquiryReq = 'OmnibusBalanceInquiryReq',
    OmnibusBalanceUpdateAck = 'OmnibusBalanceUpdateAck',
    OmnibusBalanceUpdatePendingAck = 'OmnibusBalanceUpdatePendingAck',
    OmnibusBalanceUpdateRej = 'OmnibusBalanceUpdateRej',
    OmnibusBalanceUpdateReq = 'OmnibusBalanceUpdateReq',
    OmnibusFiatBalanceInquiryAck = 'OmnibusFiatBalanceInquiryAck',
    OmnibusFiatBalanceInquiryRej = 'OmnibusFiatBalanceInquiryRej',
    OmnibusFiatBalanceInquiryReq = 'OmnibusFiatBalanceInquiryReq',
    OrderRecord = 'OrderRecord',
    PledgeParticipantRecord = 'PledgeParticipantRecord',
    PledgeParticipantReport = 'PledgeParticipantReport',
    PledgeRecord = 'PledgeRecord',
    PledgeReport = 'PledgeReport',
    PledgeTransactionRecord = 'PledgeTransactionRecord',
    PledgeTransactionReport = 'PledgeTransactionReport',
    PostingFileRecord = 'PostingFileRecord',
    PriceRecord = 'PriceRecord',
    RacfDataRecord = 'RacfDataRecord',
    StatisticsReport = 'StatisticsReport',
    StatisticsReportRecord = 'StatisticsReportRecord',
    StatisticsReports = 'StatisticsReports',
    SystemKillSwitch = 'SystemKillSwitch',
    SystemWireKillSwitch = 'SystemWireKillSwitch',
    TotalInterestWebhookAck = 'TotalInterestWebhookAck',
    TotalTokenBalance = 'TotalTokenBalance',
    Transaction = 'Transaction',
    UserAccountRecord = 'UserAccountRecord',
    UserRecord = 'UserRecord',
    UserRole = 'UserRole',
    UserSecondaryApiTypeRecord = 'UserSecondaryApiTypeRecord',
    UserValidationRecord = 'UserValidationRecord',
    ValidateApproveDeclineAck = 'ValidateApproveDeclineAck',
    ValidateApproveDeclineRej = 'ValidateApproveDeclineRej',
    ValidateApproveDeclineReq = 'ValidateApproveDeclineReq',
    ValidateCancelAck = 'ValidateCancelAck',
    ValidateCancelRej = 'ValidateCancelRej',
    ValidateCancelReq = 'ValidateCancelReq',
    WebhookSubscriptionRecord = 'WebhookSubscriptionRecord',
    WireRoleRecord = 'WireRoleRecord',
    WireTransaction = 'WireTransaction',
    WireTransactionRej = 'WireTransactionRej'
}

export type {
    AbaBicRecord,
    AbaBicRecordAck,
    AbaBicRecordRej,
    AbaFedRecord,
    AbaFedRecordAck,
    AbaFedRecordRej,
    AccountAssetRestrictionRecord,
    AccountBalanceRecord,
    AccountClientGroupRecord,
    AccountPositionRecord,
    AccountPositionSnapshotRecord,
    AccountRecord,
    AccountRelationshipRecord,
    AccountStatisticsReport,
    AccountWithdrawalDataRecord,
    AccountWithdrawalRelationshipRecord,
    ACGUserRecord,
    Activity,
    AddressBookRecord,
    AdminDepositExceptionReq,
    AdminExtRecvExceptionReq,
    AdminExtSendExceptionReq,
    AdminRedeemExceptionReq,
    Alert,
    AMLApprovalAck,
    AMLApprovalRej,
    AMLApprovalReq,
    AMLRecordApprovalAck,
    AMLRecordApprovalRej,
    AMLRecordApprovalReq,
    AMLStatusAck,
    AMLStatusRej,
    AMLStatusReq,
    APIAddConnectionReq,
    APIAddFirmConnectionReq,
    APIAddUserConnectionReq,
    APIAdminAddConnectionRequest,
    APIAdminAddUserConnectionRequest,
    APIAdminDeleteApprovedAbaRequest,
    APIAdminDeleteBicAbaRequest,
    APIAdminDeleteConnectionRequest,
    APIAdminDeleteUserConnectionRequest,
    APIAdminDeleteUserRequest,
    APIAdminModifyApprovedAbaRequest,
    APIAdminModifyBicAbaRequest,
    APIAdminModifyConnectionRequest,
    APIAdminModifyFirmConnectionRequest,
    APIAdminModifyFirmWireDataRequest,
    APIAdminModifyUserConnectionRequest,
    APIConnectionFirmsRecord,
    APIConnectionRecord,
    APIConnectionUsersRecord,
    APIDeleteConnectionReq,
    APIDeleteFirmConnectionReq,
    APIDeleteUserConnectionReq,
    APIModifyConnectionReq,
    APIModifyFirmConnectionReq,
    APIModifyUserConnectionReq,
    APITransaction,
    Asset,
    AssetBalanceStatistics,
    AvalancheGetTransactionDetailAck,
    AvalancheGetTransactionDetailRej,
    AvalancheGetTransactionDetailReq,
    BankAPIAccountInquiryAck,
    BankAPIAccountInquiryRej,
    BankAPIAccountInquiryReq,
    ClientMessageAck,
    ClientMessageRecord,
    ClientMessageRej,
    ClientMessageReq,
    ClientRoleRecord,
    CollateralHistoryDetailRecord,
    CollateralHistoryViewRecord,
    CustomerAddAbaBicAck,
    CustomerAddAbaBicRej,
    CustomerAddAbaBicReq,
    CustomerAddAbaFedAck,
    CustomerAddAbaFedRej,
    CustomerAddAbaFedReq,
    CustomerAddAccountAck,
    CustomerAddAccountRej,
    CustomerAddAccountReq,
    CustomerAddAccountWithdrawalDataAck,
    CustomerAddAccountWithdrawalDataRej,
    CustomerAddAccountWithdrawalDataReq,
    CustomerAddAccountWithdrawalRelationshipAck,
    CustomerAddAccountWithdrawalRelationshipRej,
    CustomerAddAccountWithdrawalRelationshipReq,
    CustomerAddACGAck,
    CustomerAddACGRej,
    CustomerAddACGReq,
    CustomerAddACGUserRecordAck,
    CustomerAddACGUserRecordRej,
    CustomerAddACGUserReq,
    CustomerAddAddressBookRecordAck,
    CustomerAddAddressBookRecordRej,
    CustomerAddAddressBookRecordReq,
    CustomerAddEOAKeyReq,
    CustomerAddFirmAccountAck,
    CustomerAddFirmAccountRej,
    CustomerAddFirmAccountReq,
    CustomerAddFirmAck,
    CustomerAddFirmRej,
    CustomerAddFirmReq,
    CustomerAddFirmWireDataReq,
    CustomerAddUserAccountReq,
    CustomerAddUserAck,
    CustomerAddUserRej,
    CustomerAddUserReq,
    CustomerAddUserRoleReq,
    CustomerAddWireAck,
    CustomerAddWireRej,
    CustomerAddWireReq,
    CustomerApproveDeclineAck,
    CustomerApproveDeclineRej,
    CustomerApproveDeclineReq,
    CustomerApproveUserValidationReq,
    CustomerCancelAck,
    CustomerCancelPledgeTransactionAck,
    CustomerCancelPledgeTransactionRej,
    CustomerCancelPledgeTransactionReq,
    CustomerCancelRej,
    CustomerCancelReq,
    CustomerDeleteAbaBicAck,
    CustomerDeleteAbaBicRej,
    CustomerDeleteAbaBicReq,
    CustomerDeleteAbaFedAck,
    CustomerDeleteAbaFedRej,
    CustomerDeleteAbaFedReq,
    CustomerDeleteAccountReq,
    CustomerDeleteAccountWithdrawalDataReq,
    CustomerDeleteAccountWithdrawalRelationshipAck,
    CustomerDeleteAccountWithdrawalRelationshipRej,
    CustomerDeleteAccountWithdrawalRelationshipReq,
    CustomerDeleteACGAck,
    CustomerDeleteACGRej,
    CustomerDeleteACGReq,
    CustomerDeleteACGUserAck,
    CustomerDeleteACGUserRej,
    CustomerDeleteACGUserReq,
    CustomerDeleteAddressBookRecordAck,
    CustomerDeleteAddressBookRecordRej,
    CustomerDeleteAddressBookRecordReq,
    CustomerDeleteFirmAccountAck,
    CustomerDeleteFirmAccountRej,
    CustomerDeleteFirmAccountReq,
    CustomerDeleteFirmAck,
    CustomerDeleteFirmRej,
    CustomerDeleteFirmReq,
    CustomerDeleteFirmWireDataReq,
    CustomerDeleteUserAccountReq,
    CustomerDeleteUserAck,
    CustomerDeleteUserRej,
    CustomerDeleteUserReq,
    CustomerDeleteUserRoleReq,
    CustomerDepositApprovalReq,
    CustomerDepositReq,
    CustomerModifyAbaBicAck,
    CustomerModifyAbaBicRej,
    CustomerModifyAbaBicReq,
    CustomerModifyAbaFedAck,
    CustomerModifyAbaFedRej,
    CustomerModifyAbaFedReq,
    CustomerModifyAccountReq,
    CustomerModifyAccountWithdrawalDataReq,
    CustomerModifyACGAck,
    CustomerModifyACGRej,
    CustomerModifyACGReq,
    CustomerModifyAddressBookRecordAck,
    CustomerModifyAddressBookRecordRej,
    CustomerModifyAddressBookRecordReq,
    CustomerModifyEOAKeyReq,
    CustomerModifyFirmAccountAck,
    CustomerModifyFirmAccountRej,
    CustomerModifyFirmAccountReq,
    CustomerModifyFirmAck,
    CustomerModifyFirmRej,
    CustomerModifyFirmReq,
    CustomerModifyFirmWireDataReq,
    CustomerModifyUserAccountReq,
    CustomerModifyUserAck,
    CustomerModifyUserRej,
    CustomerModifyUserReq,
    CustomerModifyUserRoleReq,
    CustomerOrderCancelAck,
    CustomerOrderCancelRej,
    CustomerOrderCancelReq,
    CustomerOrderNewAck,
    CustomerOrderNewRej,
    CustomerOrderNewReq,
    CustomerPendingApprovalAck,
    CustomerPendingApproveDeclineAck,
    CustomerPendingCancelAck,
    CustomerPendingCancelPledgeTransactionAck,
    CustomerPendingDepositAck,
    CustomerPendingOrderCancelAck,
    CustomerPendingOrderNewAck,
    CustomerPendingRedeemAck,
    CustomerPendingSendAck,
    CustomerPendingWithdrawalAck,
    CustomerPledgeAck,
    CustomerPledgeAddOnAck,
    CustomerPledgeAddOnPendingAck,
    CustomerPledgeAddOnRej,
    CustomerPledgeAddOnReq,
    CustomerPledgePendingAck,
    CustomerPledgeRej,
    CustomerPledgeReq,
    CustomerReclaimAck,
    CustomerReclaimPendingAck,
    CustomerReclaimRej,
    CustomerReclaimReq,
    CustomerRedeemApprovalReq,
    CustomerRedeemReq,
    CustomerReleaseAck,
    CustomerReleasePendingAck,
    CustomerReleaseRej,
    CustomerReleaseReq,
    CustomerSendApprovalReq,
    CustomerSendReq,
    CustomerTransferAck,
    CustomerTransferPendingAck,
    CustomerTransferRej,
    CustomerTransferReq,
    CustomerValidateBDAccountAck,
    CustomerValidateBDAccountRej,
    CustomerValidateBDAccountReq,
    CustomerWireDepositReq,
    CustomerWithdrawalAck,
    CustomerWithdrawalApprovalAck,
    CustomerWithdrawalApprovalRej,
    CustomerWithdrawalApprovalReq,
    CustomerWithdrawalRej,
    CustomerWithdrawalReq,
    EOAKeyRecord,
    ExecutionRecord,
    FeeAmountReq,
    FeeRecord,
    FirmAssetBalanceStatistics,
    FirmAssetEntitlementReport,
    FirmRecord,
    FirmSecondaryApiTypeRecord,
    FirmStatistics,
    FirmStatisticsReport,
    FirmWireDataRecord,
    HistoryAck,
    HistoryRej,
    HistoryRequest,
    LiquidityProviderOrderCancelAck,
    LiquidityProviderOrderCancelRej,
    LiquidityProviderPendingOrderCancelAck,
    LiquidityStatistics,
    NetAssetValueRecord,
    OmnibusBalanceInquiryAck,
    OmnibusBalanceInquiryRej,
    OmnibusBalanceInquiryReq,
    OmnibusBalanceUpdateAck,
    OmnibusBalanceUpdatePendingAck,
    OmnibusBalanceUpdateRej,
    OmnibusBalanceUpdateReq,
    OmnibusFiatBalanceInquiryAck,
    OmnibusFiatBalanceInquiryRej,
    OmnibusFiatBalanceInquiryReq,
    OrderRecord,
    PledgeParticipantRecord,
    PledgeParticipantReport,
    PledgeRecord,
    PledgeReport,
    PledgeTransactionRecord,
    PledgeTransactionReport,
    PostingFileRecord,
    PriceRecord,
    RacfDataRecord,
    StatisticsReport,
    StatisticsReportRecord,
    StatisticsReports,
    SystemKillSwitch,
    SystemWireKillSwitch,
    TotalInterestWebhookAck,
    TotalTokenBalance,
    Transaction,
    UserAccountRecord,
    UserRecord,
    UserRole,
    UserSecondaryApiTypeRecord,
    UserValidationRecord,
    ValidateApproveDeclineAck,
    ValidateApproveDeclineRej,
    ValidateApproveDeclineReq,
    ValidateCancelAck,
    ValidateCancelRej,
    ValidateCancelReq,
    WebhookSubscriptionRecord,
    WireRoleRecord,
    WireTransaction,
    WireTransactionRej
};

export default CoreMsg;